// removed by extract-text-webpack-plugin
module.exports = {"container":"integration-settings__container___ysAuw","iframe-container":"integration-settings__iframe-container___2-n2-","iframe":"integration-settings__iframe___3IuMW"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/integration-settings.scss
// module id = 519
// module chunks = 0